import type { RenderInstruction } from "aurelia-validation";

export class CustomValidationRenderer {

    shouldShowErrorMessage = true;

    render(instruction: RenderInstruction) {
        for (const { elements } of instruction.unrender) {
            for (const element of elements) {
                this.remove(<HTMLElement>element);
            }
        }

        for (const { result, elements } of instruction.render) {
            if (!result.valid) {
                for (const element of elements) {
                    this.add(<HTMLElement>element, result);
                }
            }
        }
        const notValid = instruction.render.filter(x => !x.result.valid);
        if (notValid.length > 0) {
            let elements = [];
            notValid.forEach(x => elements = elements.concat(x.elements));
            const sorted = elements.filter(x => x.offsetHeight > 0).sort((x, y) => this.sort(x, y));
            const elementToScrollTo = sorted[0];
            if ($(elementToScrollTo)["scrollintoview"]) {
                $(elementToScrollTo)["scrollintoview"]({ duration: 100 });
            }
        }
    }

    private sort(element1: any, element2: any): number {
        const areEqual = element1.offsetLeft === element2.offsetLeft && element1.offsetTop === element2.offsetTop;
        if (areEqual) {
            return 0;
        } else {
            const response = element1.offsetTop == element2.offsetTop ?
                element1.offsetLeft > element2.offsetLeft :
                element1.offsetTop > element2.offsetTop;
            return response ? 1 : -1;
        }
    }

    private add(element: HTMLElement, error: any) {
        if (element.classList.contains("has-error")) {
            return;
        }

        //Is is so that when the class "skip-tab-validation" is not set on a component, it will add "error-validation-tabs" instead of the previous
        //default "error-validation" because of DEL-12832
        if(!element.classList.contains("skip-tab-validation")) {
            element.classList.add("error-validation-tabs");
        }

        element.classList.add("has-error");
        element.classList.add("error-validation");
        if (this.shouldShowErrorMessage) {
            const label = $("<label>").addClass("error text-danger").html(error.message);
            const children = $(element).children();
            if (children.length > 0) {
                $($(element).children().last()).append(label);
            } else {
                $(element).after(label);
            }
        }

        if (element.tagName == "COMP-TEXT-AREA") {
            const func = () => {
                this.remove(element);
                element.removeEventListener('text-changed', func);
            };
            element.addEventListener('text-changed', func);
        } else if (element.tagName == "COMP-TEXT-BOX") {
            const func = () => {
                this.remove(element);
                element.removeEventListener('textchange', func);
            };
            element.addEventListener('textchange', func);
        } else if (element.tagName == "COMP-CHECK-BOX") {
            const func = () => {
                this.remove(element);
                element.removeEventListener('changed', func);
            };
            element.addEventListener('changed', func);
        } else if (element.tagName == "COMP-COMBO-BOX" || element.tagName == "COMP-LOOKUP-CONTROL") {
            const func = () => {
                this.remove(element);
                element.removeEventListener('selected-item-changed', func);
            };
            element.addEventListener('selected-item-changed', func);
        } else if (element.tagName == "COMP-ENTITY-FINDER") {
            const func = () => {
                this.remove(element);
                element.removeEventListener('item-selected', func);
            };
            element.addEventListener('item-selected', func);
        }
        else {
            const inputElement = element.tagName === 'INPUT' ? $(element) : $(element).find('input')
            $(inputElement)
                .one("focus", () => {
                    this.remove(element);
                });

            $(inputElement)
                .one("change", () => {
                    this.remove(element);
                });
        }
    }

    private remove(element: HTMLElement) {
        let label = $(element).find(".error");
        if (label && label.length == 0) {
            label = <any>$(element).siblings('.error');
        }
        if (label) { label.remove(); }
        element.classList.remove("has-error");
        element.classList.remove("error-validation");
        element.classList.remove("error-validation-tabs");
    }
}
